<template>
  <body data-sidebar="dark">
  <!-- Begin page -->
  <div id="layout-wrapper">
    <!-- Left Sidebar Navigation -->
    <MemberPortalNavigation />

    <!-- Main Content -->
    <div class="content-minimize">
      <div class="page-content">
        <div class="container-fluid">
          <!-- Page Title -->
          <div class="row">
            <div class="col-12">
              <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 class="mb-sm-0 font-size-18">My Beneficiaries</h4>
                <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><router-link to="/member-dashboard">Dashboard</router-link></li>
                    <li class="breadcrumb-item active">Beneficiaries</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          <!-- Summary Cards -->
          <div class="row">
            <div class="col-xl-3 col-md-6">
              <div class="card stat-card">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="flex-shrink-0">
                      <div class="stat-icon bg-soft-primary">
                        <i class="bx bx-group text-primary"></i>
                      </div>
                    </div>
                    <div class="flex-grow-1 ms-3">
                      <p class="text-muted mb-1 fw-medium">Total Covered</p>
                      <h4 class="mb-0">{{ totalCovered }}</h4>
                      <small class="text-muted">Including yourself</small>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-md-6">
              <div class="card stat-card">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="flex-shrink-0">
                      <div class="stat-icon bg-soft-success">
                        <i class="bx bx-check-circle text-success"></i>
                      </div>
                    </div>
                    <div class="flex-grow-1 ms-3">
                      <p class="text-muted mb-1 fw-medium">Active</p>
                      <h4 class="mb-0">{{ summary.active }}</h4>
                      <small class="text-muted">Dependents</small>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-md-6">
              <div class="card stat-card">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="flex-shrink-0">
                      <div class="stat-icon bg-soft-info">
                        <i class="bx bx-gift text-info"></i>
                      </div>
                    </div>
                    <div class="flex-grow-1 ms-3">
                      <p class="text-muted mb-1 fw-medium">Free Coverage</p>
                      <h4 class="mb-0">{{ summary.free_coverage }}</h4>
                      <small class="text-muted">No extra cost</small>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-md-6">
              <div class="card stat-card">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="flex-shrink-0">
                      <div class="stat-icon bg-soft-warning">
                        <i class="bx bx-wallet text-warning"></i>
                      </div>
                    </div>
                    <div class="flex-grow-1 ms-3">
                      <p class="text-muted mb-1 fw-medium">Paid Coverage</p>
                      <h4 class="mb-0">{{ summary.paid_coverage }}</h4>
                      <small class="text-muted">Additional premium</small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Special Cases Summary -->
          <div class="row" v-if="summary.with_disability > 0 || summary.with_dependency > 0">
            <div class="col-md-6" v-if="summary.with_disability > 0">
              <div class="card border-start border-4 border-purple">
                <div class="card-body py-3">
                  <div class="d-flex align-items-center">
                    <div class="flex-shrink-0">
                      <i class="bx bx-accessibility text-purple" style="font-size: 2rem;"></i>
                    </div>
                    <div class="flex-grow-1 ms-3">
                      <h5 class="mb-0">{{ summary.with_disability }} Beneficiary with Disability</h5>
                      <small class="text-muted">Eligible for free coverage exemption</small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6" v-if="summary.with_dependency > 0">
              <div class="card border-start border-4 border-info">
                <div class="card-body py-3">
                  <div class="d-flex align-items-center">
                    <div class="flex-shrink-0">
                      <i class="bx bx-heart text-info" style="font-size: 2rem;"></i>
                    </div>
                    <div class="flex-grow-1 ms-3">
                      <h5 class="mb-0">{{ summary.with_dependency }} Dependent Adult Child</h5>
                      <small class="text-muted">Eligible for free coverage exemption</small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Action Bar -->
          <div class="row mb-3">
            <div class="col-12">
              <div class="card">
                <div class="card-body py-3">
                  <div class="row align-items-center">
                    <div class="col-md-8">
                      <div class="d-flex align-items-center flex-wrap gap-2">
                        <div class="search-box me-2">
                          <div class="position-relative">
                            <input type="text" class="form-control" placeholder="Search beneficiaries..." v-model="searchQuery">
                            <i class="bx bx-search-alt search-icon"></i>
                          </div>
                        </div>
                        <select class="form-select" style="width: 150px;" v-model="filterStatus">
                          <option value="">All Status</option>
                          <option value="active">Active</option>
                          <option value="inactive">Inactive</option>
                          <option value="suspended">Suspended</option>
                        </select>
                        <select class="form-select" style="width: 180px;" v-model="filterCoverage">
                          <option value="">All Coverage</option>
                          <option value="free">Free Coverage</option>
                          <option value="paid">Paid Coverage</option>
                          <option value="disability">With Disability</option>
                          <option value="dependency">Dependent</option>
                        </select>
                      </div>
                    </div>
                    <div class="col-md-4 text-md-end mt-3 mt-md-0">
                      <span class="text-muted small">
                        <i class="bx bx-info-circle me-1"></i>Contact your local CBHI office to add or modify beneficiaries
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Loading State -->
          <div v-if="loading" class="text-center py-5">
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
            <p class="mt-3 text-muted">Loading beneficiaries...</p>
          </div>

          <!-- Beneficiaries Content -->
          <div v-else>
            <!-- Primary Member Card -->
            <div class="row">
              <div class="col-12">
                <div class="card primary-member-card">
                  <div class="card-body">
                    <div class="row align-items-center">
                      <div class="col-auto">
                        <div class="position-relative photo-container"
                             @click="hasProfilePhoto && showPhoto(profilePictureUrl, profile.full_name)"
                             :class="{ 'clickable': hasProfilePhoto }">
                          <img v-if="hasProfilePhoto"
                               :src="profilePictureUrl"
                               class="rounded-circle border border-3 border-primary shadow profile-photo-hover"
                               style="width: 80px; height: 80px; object-fit: cover;"
                               @error="handleImageError">
                          <div v-else
                               class="bg-primary rounded-circle d-flex align-items-center justify-content-center shadow"
                               style="width: 80px; height: 80px;">
                            <span class="text-white fw-bold" style="font-size: 1.5rem;">{{ getInitials(profile.full_name) }}</span>
                          </div>
                          <span class="position-absolute bottom-0 end-0 bg-success rounded-circle border border-2 border-white"
                                style="width: 20px; height: 20px;"
                                v-if="profile.status === 'active'"></span>
                          <div class="photo-overlay" v-if="hasProfilePhoto">
                            <i class="bx bx-zoom-in"></i>
                          </div>
                        </div>
                      </div>
                      <div class="col">
                        <div class="d-flex align-items-center mb-1">
                          <h5 class="mb-0 me-2">{{ profile.full_name }}</h5>
                          <span class="badge bg-primary">Primary Member</span>
                        </div>
                        <p class="text-muted mb-2">
                          <i class="bx bx-id-card me-1"></i>{{ profile.cbhi_number }}
                        </p>
                        <div class="d-flex flex-wrap gap-2">
                          <span class="badge bg-soft-info text-info">
                            <i class="bx bx-calendar me-1"></i>{{ primaryMember.age || calculateAge(profile.date_of_birth) }} years old
                          </span>
                          <span class="badge bg-soft-secondary text-secondary">
                            <i class="bx bx-user me-1"></i>{{ capitalizeFirst(profile.gender) }}
                          </span>
                          <span class="badge" :class="profile.status === 'active' ? 'bg-success' : 'bg-danger'">
                            {{ capitalizeFirst(profile.status) }}
                          </span>
                        </div>
                      </div>
                      <div class="col-auto">
                        <router-link to="/my-profile" class="btn btn-soft-primary">
                          <i class="bx bx-user me-1"></i>View Profile
                        </router-link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Plan Rules Info -->
            <div class="row mb-3" v-if="planRules.plan_name">
              <div class="col-12">
                <div class="card bg-light border-0">
                  <div class="card-body py-3">
                    <div class="d-flex align-items-center flex-wrap gap-3">
                      <span class="fw-medium"><i class="bx bx-shield-check me-1 text-primary"></i>{{ planRules.plan_name }}</span>
                      <span class="badge bg-soft-success text-success">
                        <i class="bx bx-heart me-1"></i>Free Spouses: {{ planRules.free_spouses_count }}
                      </span>
                      <span class="badge bg-soft-info text-info">
                        <i class="bx bx-child me-1"></i>Free Children Under: {{ planRules.adult_child_age_threshold }}
                      </span>
                      <span class="badge bg-soft-warning text-warning">
                        <i class="bx bx-plus-circle me-1"></i>Additional Rate: {{ planRules.additional_member_rate }}
                      </span>
                      <span class="badge bg-soft-purple text-purple" v-if="planRules.disability_exemption">
                        <i class="bx bx-accessibility me-1"></i>Disability Exemption
                      </span>
                      <span class="badge bg-soft-pink text-pink" v-if="planRules.dependency_exemption">
                        <i class="bx bx-heart me-1"></i>Dependency Exemption
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Beneficiaries Section Header -->
            <div class="row mb-3" v-if="beneficiaries.length > 0">
              <div class="col-12">
                <h5 class="section-title">
                  <i class="bx bx-group me-2"></i>Dependents ({{ filteredBeneficiaries.length }})
                </h5>
              </div>
            </div>

            <!-- Beneficiaries Grid -->
            <div class="row" v-if="filteredBeneficiaries.length > 0">
              <div class="col-xl-4 col-md-6" v-for="beneficiary in filteredBeneficiaries" :key="beneficiary.beneficiary_id">
                <div class="card beneficiary-card" :class="{ 'special-case-card': beneficiary.has_disability || beneficiary.is_dependent }">
                  <div class="card-body">
                    <!-- Status Ribbon -->
                    <div class="status-ribbon" :class="getStatusRibbonClass(beneficiary.status)">
                      {{ capitalizeFirst(beneficiary.status) }}
                    </div>

                    <!-- Special Case Indicators -->
                    <div class="special-indicators" v-if="beneficiary.has_disability || beneficiary.is_dependent">
                      <span class="special-badge disability" v-if="beneficiary.has_disability" title="Has Disability">
                        <i class="bx bx-accessibility"></i>
                      </span>
                      <span class="special-badge dependency" v-if="beneficiary.is_dependent" title="Dependent">
                        <i class="bx bx-heart"></i>
                      </span>
                    </div>

                    <!-- Profile Section -->
                    <div class="text-center mb-3">
                      <div class="position-relative d-inline-block photo-container"
                           @click="beneficiaryHasPhoto(beneficiary) && showPhoto(getBeneficiaryPhotoUrl(beneficiary), beneficiary.full_name)"
                           :class="{ 'clickable': beneficiaryHasPhoto(beneficiary) }">
                        <img v-if="beneficiaryHasPhoto(beneficiary)"
                             :src="getBeneficiaryPhotoUrl(beneficiary)"
                             class="rounded-circle border border-3 shadow-sm beneficiary-photo profile-photo-hover"
                             :class="getPhotoBorderClass(beneficiary.status)"
                             @error="onBeneficiaryImageError($event, beneficiary)">
                        <div v-else
                             class="rounded-circle d-flex align-items-center justify-content-center shadow-sm beneficiary-avatar"
                             :class="getAvatarBgClass(beneficiary.relationship)">
                          <span class="text-white fw-bold" style="font-size: 1.5rem;">{{ getInitials(beneficiary.full_name) }}</span>
                        </div>
                        <span class="position-absolute bottom-0 end-0 rounded-circle border border-2 border-white status-dot"
                              :class="beneficiary.status === 'active' ? 'bg-success' : beneficiary.status === 'pending' ? 'bg-warning' : 'bg-danger'">
                        </span>
                        <div class="photo-overlay" v-if="beneficiaryHasPhoto(beneficiary)">
                          <i class="bx bx-zoom-in"></i>
                        </div>
                      </div>
                    </div>

                    <!-- Name & Relationship -->
                    <div class="text-center mb-3">
                      <h5 class="beneficiary-name">{{ beneficiary.full_name }}</h5>
                      <span class="badge relationship-badge" :class="getRelationshipBadgeClass(beneficiary.relationship)">
                        <i :class="getRelationshipIcon(beneficiary.relationship)" class="me-1"></i>
                        {{ capitalizeFirst(beneficiary.relationship) }}
                      </span>
                    </div>

                    <!-- Info Grid -->
                    <div class="info-grid">
                      <div class="info-item">
                        <i class="bx bx-calendar text-muted"></i>
                        <div>
                          <span class="info-label">Age</span>
                          <span class="info-value">{{ beneficiary.age }} years</span>
                        </div>
                      </div>
                      <div class="info-item">
                        <i class="bx bx-user text-muted"></i>
                        <div>
                          <span class="info-label">Gender</span>
                          <span class="info-value">{{ capitalizeFirst(beneficiary.gender) }}</span>
                        </div>
                      </div>
                      <div class="info-item" v-if="beneficiary.phone_number">
                        <i class="bx bx-phone text-muted"></i>
                        <div>
                          <span class="info-label">Phone</span>
                          <span class="info-value">{{ beneficiary.phone_number }}</span>
                        </div>
                      </div>
                      <div class="info-item">
                        <i class="bx bx-time text-muted"></i>
                        <div>
                          <span class="info-label">Added</span>
                          <span class="info-value">{{ formatDate(beneficiary.created_at) }}</span>
                        </div>
                      </div>
                    </div>

                    <!-- Special Case Tags -->
                    <div class="special-case-tags mt-3" v-if="beneficiary.has_disability || beneficiary.is_dependent">
                      <div class="special-tag disability-tag" v-if="beneficiary.has_disability">
                        <i class="bx bx-accessibility me-1"></i>
                        <span>Disability</span>
                        <small v-if="beneficiary.disability_notes" class="d-block text-truncate" :title="beneficiary.disability_notes">
                          {{ truncateText(beneficiary.disability_notes, 30) }}
                        </small>
                      </div>
                      <div class="special-tag dependency-tag" v-if="beneficiary.is_dependent">
                        <i class="bx bx-heart me-1"></i>
                        <span>Dependent</span>
                        <small v-if="beneficiary.dependency_notes" class="d-block text-truncate" :title="beneficiary.dependency_notes">
                          {{ truncateText(beneficiary.dependency_notes, 30) }}
                        </small>
                      </div>
                    </div>

                    <!-- Coverage Badge -->
                    <div class="coverage-badge text-center mt-3">
                      <span class="badge" :class="beneficiary.is_free_coverage ? 'bg-soft-success text-success' : 'bg-soft-warning text-warning'">
                        <i :class="beneficiary.is_free_coverage ? 'bx bx-check' : 'bx bx-wallet'" class="me-1"></i>
                        {{ beneficiary.is_free_coverage ? 'Free Coverage' : 'ETB ' + formatCurrency(beneficiary.charge_amount) + '/year' }}
                      </span>
                      <div class="coverage-reason small text-muted mt-1">
                        {{ beneficiary.coverage_reason }}
                      </div>
                    </div>

                    <!-- Action Button -->
                    <div class="text-center mt-3">
                      <button class="btn btn-soft-primary btn-sm" @click="viewBeneficiary(beneficiary)">
                        <i class="bx bx-show me-1"></i>View Details
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- No Beneficiaries -->
            <div class="row" v-else-if="beneficiaries.length === 0">
              <div class="col-12">
                <div class="card">
                  <div class="card-body text-center py-5">
                    <i class="bx bx-group text-muted" style="font-size: 4rem; opacity: 0.5;"></i>
                    <h5 class="text-muted mt-3">No Dependents Registered</h5>
                    <p class="text-muted mb-0">You don't have any dependents registered under your CBHI coverage.</p>
                    <p class="text-muted small">To add family members, please visit your local CBHI office.</p>
                  </div>
                </div>
              </div>
            </div>

            <!-- No Results from Filter -->
            <div class="row" v-else-if="filteredBeneficiaries.length === 0 && beneficiaries.length > 0">
              <div class="col-12">
                <div class="card">
                  <div class="card-body text-center py-4">
                    <i class="bx bx-search-alt text-muted" style="font-size: 3rem;"></i>
                    <h5 class="text-muted mt-3">No Results Found</h5>
                    <p class="text-muted">No beneficiaries match your search criteria.</p>
                    <button class="btn btn-outline-primary btn-sm" @click="clearFilters">
                      <i class="bx bx-refresh me-1"></i>Clear Filters
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!-- Coverage Info Card -->
            <div class="row mt-4">
              <div class="col-12">
                <div class="card bg-light border-0">
                  <div class="card-body">
                    <div class="row align-items-center">
                      <div class="col-md-8">
                        <h6 class="mb-2"><i class="bx bx-info-circle text-primary me-2"></i>About Beneficiary Coverage</h6>
                        <p class="text-muted mb-0 small">
                          Your plan ({{ planRules.plan_name }}) provides free coverage for spouses and children under {{ planRules.adult_child_age_threshold }}.
                          <span v-if="planRules.disability_exemption">
                            <strong>Adult children with disabilities</strong> are also covered free.
                          </span>
                          <span v-if="planRules.dependency_exemption">
                            <strong>Dependent adult children</strong> (students, etc.) qualify for free coverage.
                          </span>
                          Additional members are charged at {{ planRules.additional_member_rate }} of the primary premium.
                          To add or modify beneficiaries, please visit your local CBHI office.
                        </p>
                      </div>
                      <div class="col-md-4 text-md-end mt-3 mt-md-0">
                        <router-link to="/member-coverage" class="btn btn-outline-primary btn-sm">
                          <i class="bx bx-shield-check me-1"></i>View Full Coverage
                        </router-link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>

  <!-- View Beneficiary Modal -->
  <div class="modal-overlay" v-if="showViewModal" @click.self="closeViewModal">
    <div class="modal-container modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Beneficiary Details</h5>
          <button type="button" class="btn-close" @click="closeViewModal"></button>
        </div>
        <div class="modal-body" v-if="selectedBeneficiary">
          <!-- Profile Section -->
          <div class="text-center mb-4">
            <div class="photo-container d-inline-block"
                 @click="beneficiaryHasPhoto(selectedBeneficiary) && showPhoto(getBeneficiaryPhotoUrl(selectedBeneficiary), selectedBeneficiary.full_name)"
                 :class="{ 'clickable': beneficiaryHasPhoto(selectedBeneficiary) }">
              <img v-if="beneficiaryHasPhoto(selectedBeneficiary)"
                   :src="getBeneficiaryPhotoUrl(selectedBeneficiary)"
                   class="rounded-circle border border-3 shadow profile-photo-hover"
                   style="width: 100px; height: 100px; object-fit: cover;">
              <div v-else
                   class="rounded-circle d-flex align-items-center justify-content-center shadow mx-auto"
                   :class="getAvatarBgClass(selectedBeneficiary.relationship)"
                   style="width: 100px; height: 100px;">
                <span class="text-white fw-bold" style="font-size: 2rem;">{{ getInitials(selectedBeneficiary.full_name) }}</span>
              </div>
              <div class="photo-overlay" v-if="beneficiaryHasPhoto(selectedBeneficiary)">
                <i class="bx bx-zoom-in"></i>
              </div>
            </div>
            <h5 class="mt-3 mb-1">{{ selectedBeneficiary.full_name }}</h5>
            <div class="d-flex justify-content-center gap-2 flex-wrap">
              <span class="badge" :class="getRelationshipBadgeClass(selectedBeneficiary.relationship)">
                {{ capitalizeFirst(selectedBeneficiary.relationship) }}
              </span>
              <span class="badge bg-soft-purple text-purple" v-if="selectedBeneficiary.has_disability">
                <i class="bx bx-accessibility me-1"></i>Disability
              </span>
              <span class="badge bg-soft-pink text-pink" v-if="selectedBeneficiary.is_dependent">
                <i class="bx bx-heart me-1"></i>Dependent
              </span>
            </div>
          </div>

          <!-- Basic Information -->
          <div class="detail-section mb-4">
            <h6 class="detail-section-title">
              <i class="bx bx-user me-2"></i>Basic Information
            </h6>
            <div class="detail-list">
              <div class="detail-item">
                <span class="detail-label">Status</span>
                <span class="badge" :class="selectedBeneficiary.status === 'active' ? 'bg-success' : 'bg-warning'">
                  {{ capitalizeFirst(selectedBeneficiary.status) }}
                </span>
              </div>
              <div class="detail-item" v-if="selectedBeneficiary.grandfather_name">
                <span class="detail-label">Grandfather Name</span>
                <span class="detail-value">{{ selectedBeneficiary.grandfather_name }}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">Date of Birth</span>
                <span class="detail-value">{{ formatDate(selectedBeneficiary.date_of_birth) }}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">Age</span>
                <span class="detail-value">{{ selectedBeneficiary.age }} years</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">Gender</span>
                <span class="detail-value">{{ capitalizeFirst(selectedBeneficiary.gender) }}</span>
              </div>
              <div class="detail-item" v-if="selectedBeneficiary.id_number">
                <span class="detail-label">ID Number</span>
                <span class="detail-value">{{ selectedBeneficiary.id_number }}</span>
              </div>
              <div class="detail-item" v-if="selectedBeneficiary.phone_number">
                <span class="detail-label">Phone Number</span>
                <span class="detail-value">{{ selectedBeneficiary.phone_number }}</span>
              </div>
            </div>
          </div>

          <!-- Medical Information -->
          <div class="detail-section mb-4" v-if="selectedBeneficiary.blood_group || selectedBeneficiary.allergies || selectedBeneficiary.chronic_conditions">
            <h6 class="detail-section-title">
              <i class="bx bx-plus-medical me-2"></i>Medical Information
            </h6>
            <div class="detail-list">
              <div class="detail-item" v-if="selectedBeneficiary.blood_group">
                <span class="detail-label">Blood Group</span>
                <span class="detail-value">{{ selectedBeneficiary.blood_group }}</span>
              </div>
              <div class="detail-item" v-if="selectedBeneficiary.allergies">
                <span class="detail-label">Allergies</span>
                <span class="detail-value">{{ selectedBeneficiary.allergies }}</span>
              </div>
              <div class="detail-item" v-if="selectedBeneficiary.chronic_conditions">
                <span class="detail-label">Chronic Conditions</span>
                <span class="detail-value">{{ selectedBeneficiary.chronic_conditions }}</span>
              </div>
            </div>
          </div>

          <!-- Special Cases Section -->
          <div class="detail-section mb-4" v-if="selectedBeneficiary.has_disability || selectedBeneficiary.is_dependent">
            <h6 class="detail-section-title">
              <i class="bx bx-star me-2"></i>Special Case Information
            </h6>

            <!-- Disability Info -->
            <div class="special-case-box disability-box" v-if="selectedBeneficiary.has_disability">
              <div class="special-case-header">
                <i class="bx bx-accessibility"></i>
                <span>Disability Status</span>
                <span class="badge bg-success ms-auto">Verified</span>
              </div>
              <div class="special-case-content" v-if="selectedBeneficiary.disability_notes">
                <strong>Notes:</strong>
                <p class="mb-0 mt-1">{{ selectedBeneficiary.disability_notes }}</p>
              </div>
              <div class="special-case-benefit">
                <i class="bx bx-check-circle text-success me-1"></i>
                Eligible for free coverage as adult child with disability
              </div>
            </div>

            <!-- Dependency Info -->
            <div class="special-case-box dependency-box" v-if="selectedBeneficiary.is_dependent">
              <div class="special-case-header">
                <i class="bx bx-heart"></i>
                <span>Dependency Status</span>
                <span class="badge bg-success ms-auto">Verified</span>
              </div>
              <div class="special-case-content" v-if="selectedBeneficiary.dependency_notes">
                <strong>Notes:</strong>
                <p class="mb-0 mt-1">{{ selectedBeneficiary.dependency_notes }}</p>
              </div>
              <div class="special-case-benefit">
                <i class="bx bx-check-circle text-success me-1"></i>
                Eligible for free coverage as dependent adult child
              </div>
            </div>
          </div>

          <!-- Coverage Information -->
          <div class="detail-section mb-4">
            <h6 class="detail-section-title">
              <i class="bx bx-shield-check me-2"></i>Coverage Information
            </h6>
            <div class="coverage-summary" :class="selectedBeneficiary.is_free_coverage ? 'coverage-free' : 'coverage-paid'">
              <div class="coverage-icon">
                <i :class="selectedBeneficiary.is_free_coverage ? 'bx bx-check-circle' : 'bx bx-wallet'"></i>
              </div>
              <div class="coverage-details">
                <h5 class="mb-1">{{ selectedBeneficiary.is_free_coverage ? 'Free Coverage' : 'ETB ' + formatCurrency(selectedBeneficiary.charge_amount) + '/year' }}</h5>
                <p class="mb-0">{{ selectedBeneficiary.coverage_reason }}</p>
              </div>
            </div>
          </div>

          <!-- Additional Info -->
          <div class="detail-section">
            <h6 class="detail-section-title">
              <i class="bx bx-info-circle me-2"></i>Additional Information
            </h6>
            <div class="detail-list">
              <div class="detail-item" v-if="selectedBeneficiary.notes">
                <span class="detail-label">Notes</span>
                <span class="detail-value">{{ selectedBeneficiary.notes }}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">Added On</span>
                <span class="detail-value">{{ formatDate(selectedBeneficiary.created_at) }}</span>
              </div>
              <div class="detail-item" v-if="selectedBeneficiary.updated_at">
                <span class="detail-label">Last Updated</span>
                <span class="detail-value">{{ formatDate(selectedBeneficiary.updated_at) }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" @click="closeViewModal">Close</button>
        </div>
      </div>
    </div>
  </div>

  <!-- Photo Preview Modal -->
  <div class="photo-preview-overlay" v-if="showPhotoPreview" @click.self="closePhotoPreview">
    <div class="photo-preview-container">
      <button class="photo-preview-close" @click="closePhotoPreview">
        <i class="bx bx-x"></i>
      </button>
      <img :src="previewPhotoUrl" :alt="previewPhotoName" class="photo-preview-image">
      <div class="photo-preview-name">{{ previewPhotoName }}</div>
    </div>
  </div>

  </body>
</template>

<script>
/* eslint-disable */
import MemberPortalNavigation from "@/components/member-portal/MemberPortalNavigation.vue";
import { memberUrl, executeJson } from "@/api";

export default {
  name: "BeneficiariesList",
  components: {
    MemberPortalNavigation
  },

  data() {
    return {
      loading: false,

      // Profile data
      profile: {},
      planInfo: {},
      beneficiaries: [],
      primaryMember: {},
      summary: {
        total: 0,
        active: 0,
        inactive: 0,
        suspended: 0,
        free_coverage: 0,
        paid_coverage: 0,
        with_disability: 0,
        with_dependency: 0
      },
      planRules: {
        plan_name: '',
        free_spouses_count: 1,
        adult_child_age_threshold: 18,
        additional_member_rate: '20%',
        additional_member_fee: 0,
        disability_exemption: true,
        dependency_exemption: true
      },

      // Filters
      searchQuery: '',
      filterStatus: '',
      filterCoverage: '',

      // Modal
      selectedBeneficiary: null,
      showViewModal: false,

      // Photo preview
      showPhotoPreview: false,
      previewPhotoUrl: '',
      previewPhotoName: ''
    };
  },

  computed: {
    // Photo URL
    profilePictureUrl() {
      if (this.profile.profile_photo) {
        if (this.profile.profile_photo.startsWith('http')) {
          return this.profile.profile_photo;
        }
        return `https://rcmsuat.craftsilicon.com/api1/uploads/member-photos/${this.profile.profile_photo}`;
      }
      return './assets/images/users/default-avatar.png';
    },

    hasProfilePhoto() {
      return this.profile && this.profile.profile_photo;
    },

    // Total covered (self + beneficiaries)
    totalCovered() {
      return 1 + this.summary.total;
    },

    // Filtered beneficiaries
    filteredBeneficiaries() {
      let result = [...this.beneficiaries];

      // Search filter
      if (this.searchQuery) {
        const query = this.searchQuery.toLowerCase();
        result = result.filter(b =>
            b.full_name.toLowerCase().includes(query) ||
            (b.relationship && b.relationship.toLowerCase().includes(query)) ||
            (b.disability_notes && b.disability_notes.toLowerCase().includes(query)) ||
            (b.dependency_notes && b.dependency_notes.toLowerCase().includes(query))
        );
      }

      // Status filter
      if (this.filterStatus) {
        result = result.filter(b => b.status === this.filterStatus);
      }

      // Coverage filter
      if (this.filterCoverage) {
        switch (this.filterCoverage) {
          case 'free':
            result = result.filter(b => b.is_free_coverage);
            break;
          case 'paid':
            result = result.filter(b => !b.is_free_coverage);
            break;
          case 'disability':
            result = result.filter(b => b.has_disability);
            break;
          case 'dependency':
            result = result.filter(b => b.is_dependent);
            break;
        }
      }

      return result;
    }
  },

  mounted() {
    this.loadData();
  },

  methods: {
    // Load all data
    async loadData() {
      this.loading = true;

      try {
        await Promise.all([
          this.loadMemberProfile(),
          this.loadBeneficiaries()
        ]);
      } catch (error) {
        console.error('Error loading data:', error);
      } finally {
        this.loading = false;
      }
    },

    // Load member profile
    async loadMemberProfile() {
      const data = {
        function: "getMyMemberProfile"
      };

      try {
        const res = await executeJson(data, memberUrl);

        if (res.data.success) {
          this.profile = res.data.data.profile || {};
          this.planInfo = res.data.data.planInfo || {};
        }
      } catch (error) {
        console.error('Error loading profile:', error);
      }
    },

    // Load beneficiaries with new API structure
    async loadBeneficiaries() {
      const data = {
        function: "getMyBeneficiaries"
      };

      try {
        const res = await executeJson(data, memberUrl);

        if (res.data.success) {
          // Get beneficiaries array
          this.beneficiaries = res.data.data.beneficiaries || [];

          // Get primary member info
          this.primaryMember = res.data.data.primary_member || {};

          // Get summary with disability/dependency counts
          this.summary = res.data.data.summary || {
            total: this.beneficiaries.length,
            active: this.beneficiaries.filter(b => b.status === 'active').length,
            inactive: 0,
            suspended: 0,
            free_coverage: 0,
            paid_coverage: 0,
            with_disability: 0,
            with_dependency: 0
          };

          // Get plan rules
          if (res.data.data.plan_rules) {
            this.planRules = res.data.data.plan_rules;
          }
        }
      } catch (error) {
        console.error('Error loading beneficiaries:', error);
      }
    },

    // View beneficiary
    viewBeneficiary(beneficiary) {
      this.selectedBeneficiary = beneficiary;
      this.showViewModal = true;
    },

    // Close view modal
    closeViewModal() {
      this.showViewModal = false;
      this.selectedBeneficiary = null;
    },

    // Show photo preview
    showPhoto(photoUrl, name) {
      this.previewPhotoUrl = photoUrl;
      this.previewPhotoName = name;
      this.showPhotoPreview = true;
    },

    // Close photo preview
    closePhotoPreview() {
      this.showPhotoPreview = false;
      this.previewPhotoUrl = '';
      this.previewPhotoName = '';
    },

    // Clear filters
    clearFilters() {
      this.searchQuery = '';
      this.filterStatus = '';
      this.filterCoverage = '';
    },

    // Truncate text
    truncateText(text, maxLength) {
      if (!text) return '';
      if (text.length <= maxLength) return text;
      return text.substring(0, maxLength) + '...';
    },

    // Status ribbon class
    getStatusRibbonClass(status) {
      const classes = {
        'active': 'ribbon-success',
        'pending': 'ribbon-warning',
        'inactive': 'ribbon-secondary',
        'suspended': 'ribbon-danger',
        'removed': 'ribbon-secondary'
      };
      return classes[status] || 'ribbon-secondary';
    },

    // Photo border class
    getPhotoBorderClass(status) {
      const classes = {
        'active': 'border-success',
        'pending': 'border-warning',
        'suspended': 'border-danger'
      };
      return classes[status] || 'border-secondary';
    },

    // Avatar background class
    getAvatarBgClass(relationship) {
      const classes = {
        'spouse': 'bg-info',
        'child': 'bg-success',
        'son': 'bg-success',
        'daughter': 'bg-pink',
        'parent': 'bg-warning',
        'father': 'bg-warning',
        'mother': 'bg-purple',
        'sibling': 'bg-secondary',
        'grandparent': 'bg-orange',
        'grandchild': 'bg-teal'
      };
      return classes[relationship?.toLowerCase()] || 'bg-primary';
    },

    // Relationship badge class
    getRelationshipBadgeClass(relationship) {
      const classes = {
        'spouse': 'bg-soft-info text-info',
        'child': 'bg-soft-success text-success',
        'son': 'bg-soft-success text-success',
        'daughter': 'bg-soft-pink text-pink',
        'parent': 'bg-soft-warning text-warning',
        'father': 'bg-soft-warning text-warning',
        'mother': 'bg-soft-purple text-purple',
        'sibling': 'bg-soft-secondary text-secondary',
        'grandparent': 'bg-soft-orange text-orange',
        'grandchild': 'bg-soft-teal text-teal'
      };
      return classes[relationship?.toLowerCase()] || 'bg-soft-primary text-primary';
    },

    // Relationship icon
    getRelationshipIcon(relationship) {
      const icons = {
        'spouse': 'bx bx-heart',
        'child': 'bx bx-child',
        'son': 'bx bx-male',
        'daughter': 'bx bx-female',
        'parent': 'bx bx-user',
        'father': 'bx bx-male',
        'mother': 'bx bx-female',
        'sibling': 'bx bx-group',
        'grandparent': 'bx bx-user',
        'grandchild': 'bx bx-child'
      };
      return icons[relationship?.toLowerCase()] || 'bx bx-user';
    },

    // Image handlers
    handleImageError(event) {
      event.target.style.display = 'none';
      this.profile.profile_photo = null;
    },

    getBeneficiaryPhotoUrl(beneficiary) {
      if (beneficiary.profile_photo) {
        if (beneficiary.profile_photo.startsWith('http')) {
          return beneficiary.profile_photo;
        }
        return `https://api.craftcollect.africa/cbhi/uploads/beneficiary-photos/${beneficiary.profile_photo}`;
      }
      return null;
    },

    beneficiaryHasPhoto(beneficiary) {
      return beneficiary && beneficiary.profile_photo;
    },

    onBeneficiaryImageError(event, beneficiary) {
      event.target.style.display = 'none';
      const index = this.beneficiaries.findIndex(b => b.beneficiary_id === beneficiary.beneficiary_id);
      if (index !== -1) {
        this.beneficiaries[index].profile_photo = null;
      }
    },

    // Utility methods
    getInitials(name) {
      if (!name) return '?';
      const parts = name.trim().split(' ');
      if (parts.length >= 2) {
        return (parts[0][0] + parts[1][0]).toUpperCase();
      }
      return name.substring(0, 2).toUpperCase();
    },

    calculateAge(dob) {
      if (!dob) return 'N/A';
      const birthDate = new Date(dob);
      const today = new Date();
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDiff = today.getMonth() - birthDate.getMonth();
      if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      return age;
    },

    formatDate(date) {
      if (!date) return 'N/A';
      return new Date(date).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      });
    },

    formatCurrency(amount) {
      if (!amount) return '0';
      return new Intl.NumberFormat().format(amount);
    },

    capitalizeFirst(str) {
      if (!str) return '';
      return str.charAt(0).toUpperCase() + str.slice(1).replace(/_/g, ' ');
    }
  }
};
</script>

<style scoped>
/* Content area with sidebar */
.content-minimize {
  margin-left: 250px;
  transition: margin-left 0.3s ease;
}

.page-content {
  padding: 70px 0 60px 0;
  min-height: 100vh;
  background-color: #f8f9fa;
}

@media (max-width: 992px) {
  .content-minimize {
    margin-left: 0 !important;
  }
}

.vertical-collpsed .content-minimize {
  margin-left: 70px;
}

/* Stat Cards */
.stat-card {
  border: none;
  border-radius: 0.75rem;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  transition: all 0.3s ease;
}

.stat-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.1);
}

.stat-icon {
  width: 50px;
  height: 50px;
  border-radius: 0.75rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
}

/* Soft Backgrounds */
.bg-soft-primary { background-color: rgba(44, 90, 160, 0.15); }
.bg-soft-success { background-color: rgba(40, 167, 69, 0.15); }
.bg-soft-info { background-color: rgba(23, 162, 184, 0.15); }
.bg-soft-warning { background-color: rgba(255, 193, 7, 0.15); }
.bg-soft-danger { background-color: rgba(220, 53, 69, 0.15); }
.bg-soft-secondary { background-color: rgba(108, 117, 125, 0.15); }
.bg-soft-pink { background-color: rgba(232, 62, 140, 0.15); }
.bg-soft-purple { background-color: rgba(111, 66, 193, 0.15); }
.bg-soft-orange { background-color: rgba(253, 126, 20, 0.15); }
.bg-soft-teal { background-color: rgba(32, 201, 151, 0.15); }

.text-pink { color: #e83e8c; }
.text-purple { color: #6f42c1; }
.text-orange { color: #fd7e14; }
.text-teal { color: #20c997; }
.bg-pink { background-color: #e83e8c; }
.bg-purple { background-color: #6f42c1; }
.bg-orange { background-color: #fd7e14; }
.bg-teal { background-color: #20c997; }

.border-purple { border-color: #6f42c1 !important; }
.border-info { border-color: #17a2b8 !important; }

/* Search Box */
.search-box {
  position: relative;
  min-width: 200px;
}

.search-box .form-control {
  padding-left: 40px;
  border-radius: 0.5rem;
}

.search-box .search-icon {
  position: absolute;
  left: 13px;
  top: 50%;
  transform: translateY(-50%);
  color: #74788d;
}

/* Cards */
.card {
  border: none;
  border-radius: 0.75rem;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
}

/* Primary Member Card */
.primary-member-card {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-left: 4px solid #2c5aa0;
}

/* Section Title */
.section-title {
  font-size: 1rem;
  font-weight: 600;
  color: #495057;
  display: flex;
  align-items: center;
}

/* Beneficiary Card */
.beneficiary-card {
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
}

.beneficiary-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
}

/* Special Case Card Highlight */
.special-case-card {
  border-left: 4px solid #6f42c1;
}

.special-case-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, #6f42c1, #e83e8c);
}

/* Special Indicators */
.special-indicators {
  position: absolute;
  top: 10px;
  left: 10px;
  display: flex;
  gap: 5px;
  z-index: 5;
}

.special-badge {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 0.85rem;
  box-shadow: 0 2px 4px rgba(0,0,0,0.2);
}

.special-badge.disability {
  background: linear-gradient(135deg, #6f42c1, #8b5cf6);
}

.special-badge.dependency {
  background: linear-gradient(135deg, #e83e8c, #f472b6);
}

/* Special Case Tags */
.special-case-tags {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.special-tag {
  padding: 8px 12px;
  border-radius: 8px;
  font-size: 0.8rem;
}

.special-tag.disability-tag {
  background: linear-gradient(135deg, rgba(111, 66, 193, 0.1), rgba(139, 92, 246, 0.1));
  border-left: 3px solid #6f42c1;
  color: #6f42c1;
}

.special-tag.dependency-tag {
  background: linear-gradient(135deg, rgba(232, 62, 140, 0.1), rgba(244, 114, 182, 0.1));
  border-left: 3px solid #e83e8c;
  color: #e83e8c;
}

.special-tag small {
  color: #6c757d;
  font-size: 0.7rem;
}

/* Coverage Badge */
.coverage-badge .badge {
  font-size: 0.8rem;
  padding: 0.4rem 0.8rem;
}

.coverage-reason {
  font-size: 0.75rem;
}

/* Status Ribbon */
.status-ribbon {
  position: absolute;
  top: 15px;
  right: -35px;
  padding: 5px 40px;
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  transform: rotate(45deg);
  color: white;
}

.ribbon-success { background: #28a745; }
.ribbon-warning { background: #ffc107; color: #1e3f70; }
.ribbon-danger { background: #dc3545; }
.ribbon-secondary { background: #6c757d; }

/* Beneficiary Photo */
.beneficiary-photo {
  width: 80px;
  height: 80px;
  object-fit: cover;
}

.beneficiary-avatar {
  width: 80px;
  height: 80px;
}

.status-dot {
  width: 18px;
  height: 18px;
}

/* Beneficiary Name */
.beneficiary-name {
  font-size: 1.1rem;
  font-weight: 600;
  color: #1e3f70;
  margin-bottom: 0.5rem;
}

/* Relationship Badge */
.relationship-badge {
  font-size: 0.75rem;
  padding: 0.35rem 0.75rem;
}

/* Info Grid */
.info-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.75rem;
}

.info-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.info-item i {
  font-size: 1rem;
}

.info-item div {
  display: flex;
  flex-direction: column;
}

.info-label {
  font-size: 0.7rem;
  color: #6c757d;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.info-value {
  font-size: 0.85rem;
  font-weight: 500;
  color: #495057;
}

/* Soft Buttons */
.btn-soft-primary {
  background-color: rgba(44, 90, 160, 0.1);
  color: #2c5aa0;
  border: none;
}

.btn-soft-primary:hover {
  background-color: #2c5aa0;
  color: #fff;
}

.btn-soft-info {
  background-color: rgba(23, 162, 184, 0.1);
  color: #17a2b8;
  border: none;
}

.btn-soft-info:hover {
  background-color: #17a2b8;
  color: #fff;
}

.btn-soft-danger {
  background-color: rgba(220, 53, 69, 0.1);
  color: #dc3545;
  border: none;
}

.btn-soft-danger:hover {
  background-color: #dc3545;
  color: #fff;
}

/* Detail Section */
.detail-section {
  margin-bottom: 1.5rem;
}

.detail-section-title {
  font-size: 0.9rem;
  font-weight: 600;
  color: #1e3f70;
  margin-bottom: 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid #e9ecef;
  display: flex;
  align-items: center;
}

/* Detail List */
.detail-list {
  background: #f8f9fa;
  border-radius: 0.5rem;
  padding: 1rem;
}

.detail-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 0;
  border-bottom: 1px solid #e9ecef;
}

.detail-item:last-child {
  border-bottom: none;
}

.detail-label {
  font-size: 0.875rem;
  color: #6c757d;
}

.detail-value {
  font-size: 0.875rem;
  font-weight: 500;
}

/* Special Case Box in Modal */
.special-case-box {
  border-radius: 10px;
  padding: 1rem;
  margin-bottom: 1rem;
}

.special-case-box.disability-box {
  background: linear-gradient(135deg, rgba(111, 66, 193, 0.08), rgba(139, 92, 246, 0.08));
  border: 1px solid rgba(111, 66, 193, 0.2);
}

.special-case-box.dependency-box {
  background: linear-gradient(135deg, rgba(232, 62, 140, 0.08), rgba(244, 114, 182, 0.08));
  border: 1px solid rgba(232, 62, 140, 0.2);
}

.special-case-header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 600;
  margin-bottom: 0.75rem;
}

.special-case-box.disability-box .special-case-header {
  color: #6f42c1;
}

.special-case-box.dependency-box .special-case-header {
  color: #e83e8c;
}

.special-case-header i {
  font-size: 1.25rem;
}

.special-case-content {
  background: white;
  padding: 0.75rem;
  border-radius: 6px;
  margin-bottom: 0.75rem;
  font-size: 0.875rem;
}

.special-case-benefit {
  font-size: 0.8rem;
  color: #28a745;
  display: flex;
  align-items: center;
}

/* Coverage Summary */
.coverage-summary {
  display: flex;
  align-items: center;
  padding: 1.25rem;
  border-radius: 10px;
  gap: 1rem;
}

.coverage-summary.coverage-free {
  background: linear-gradient(135deg, rgba(40, 167, 69, 0.1), rgba(32, 201, 151, 0.1));
  border: 1px solid rgba(40, 167, 69, 0.2);
}

.coverage-summary.coverage-paid {
  background: linear-gradient(135deg, rgba(255, 193, 7, 0.1), rgba(253, 126, 20, 0.1));
  border: 1px solid rgba(255, 193, 7, 0.2);
}

.coverage-icon {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
}

.coverage-free .coverage-icon {
  background: rgba(40, 167, 69, 0.2);
  color: #28a745;
}

.coverage-paid .coverage-icon {
  background: rgba(255, 193, 7, 0.2);
  color: #ffc107;
}

.coverage-details h5 {
  margin: 0;
  font-weight: 600;
}

.coverage-free .coverage-details h5 {
  color: #28a745;
}

.coverage-paid .coverage-details h5 {
  color: #fd7e14;
}

.coverage-details p {
  color: #6c757d;
  font-size: 0.875rem;
}

/* Responsive */
@media (max-width: 768px) {
  .info-grid {
    grid-template-columns: 1fr;
  }

  .beneficiary-photo,
  .beneficiary-avatar {
    width: 70px;
    height: 70px;
  }

  .status-ribbon {
    font-size: 0.6rem;
    padding: 4px 35px;
    right: -38px;
    top: 12px;
  }

  .special-indicators {
    top: 8px;
    left: 8px;
  }

  .special-badge {
    width: 24px;
    height: 24px;
    font-size: 0.75rem;
  }
}

/* Custom Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
  padding: 1rem;
}

.modal-container {
  width: 100%;
  max-width: 500px;
  max-height: 90vh;
  overflow-y: auto;
}

.modal-container.modal-lg {
  max-width: 650px;
}

.modal-container.modal-sm {
  max-width: 350px;
}

.modal-content {
  background: white;
  border-radius: 0.75rem;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.25rem;
  border-bottom: 1px solid #e9ecef;
}

.modal-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: #1e3f70;
  margin: 0;
}

.modal-body {
  padding: 1.25rem;
  max-height: 70vh;
  overflow-y: auto;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  padding: 1rem 1.25rem;
  border-top: 1px solid #e9ecef;
}

.btn-close {
  background: transparent;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  padding: 0;
  line-height: 1;
  color: #6c757d;
}

.btn-close:hover {
  color: #1e3f70;
}

.btn-close::before {
  content: "×";
}

/* Photo Hover Effects */
.photo-container {
  position: relative;
  display: inline-block;
}

.photo-container.clickable {
  cursor: pointer;
}

.photo-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.photo-overlay i {
  color: white;
  font-size: 1.5rem;
}

.photo-container.clickable:hover .photo-overlay {
  opacity: 1;
}

.profile-photo-hover {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.photo-container.clickable:hover .profile-photo-hover {
  transform: scale(1.05);
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.2);
}

/* Photo Preview Modal */
.photo-preview-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1100;
  padding: 2rem;
}

.photo-preview-container {
  position: relative;
  max-width: 90%;
  max-height: 90%;
  text-align: center;
}

.photo-preview-close {
  position: absolute;
  top: -50px;
  right: 0;
  background: transparent;
  border: none;
  color: white;
  font-size: 2.5rem;
  cursor: pointer;
  padding: 0.5rem;
  line-height: 1;
  transition: transform 0.2s ease;
  z-index: 10;
}

.photo-preview-close:hover {
  transform: scale(1.2);
  color: #ff6b6b;
}

.photo-preview-image {
  max-width: 100%;
  max-height: 80vh;
  border-radius: 0.5rem;
  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.5);
  object-fit: contain;
}

.photo-preview-name {
  color: white;
  margin-top: 1rem;
  font-size: 1.1rem;
  font-weight: 500;
}
</style>